import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { finalize, tap } from 'rxjs';
import { ApiUrls } from 'src/app/shared/const/Api-urls';
import { AddressCO, EnquiryType, PageCategoryCO, PageCategoryType, PageCO, PageContentCO, PageImageCO, SchoolCO, SourceType, VisitorCO, VisitorStatus } from 'src/app/shared/models/ApiModels';
import { ApiService } from 'src/app/shared/services/api.service';
import { PageDataService } from 'src/app/shared/services/page-data.service';
import { environment } from 'src/environments/environment';

export interface PeriodicElement {
  class: string;
  slno: number;
  fees: string;
}

export interface PeriodicElement1 {
  class: string;
  slno: number;
  criteria: string;
}
interface ContactFormModel {
  visitorName: FormControl<string | null>;
  emailId: FormControl<string | null>;
  phoneNo: FormControl<string | null>;
  admissionClass: FormControl<string | null>;
  remarks: FormControl<string | null>;
}
const ELEMENT_DATA: PeriodicElement[] = [
  {slno: 1, class: 'NURSERY - UKG', fees:'ADMISSION FEE -  ₹3400  TUTION FEE -  ₹2100  ANNUAL FEE - ₹4600   EXAM FEE - ₹0   ELECTRIC FEE - ₹400  '},
  {slno: 2, class: 'CLASS I & II', fees: 'ADMISSION FEE -  ₹3400   TUTION FEE - ₹2400   ANNUAL FEE - ₹4800   EXAM FEE - ₹1100   ELECTRIC FEE - ₹400  '},
  {slno: 3, class: 'CLASS III & IV', fees:'ADMISSION FEE -  ₹3400   TUTION FEE - ₹2500   ANNUAL FEE - ₹4800   EXAM FEE - ₹1200   ELECTRIC FEE - ₹400  '},
  {slno: 4, class: 'CLASS V', fees: 'ADMISSION FEE -  ₹3400   TUTION FEE - ₹2600   ANNUAL FEE - ₹4900   EXAM FEE - ₹1200   ELECTRIC FEE - ₹400  '},
  {slno: 5, class: 'CLASS VI', fees:'ADMISSION FEE -  ₹3400   TUTION FEE - ₹2100   ANNUAL FEE - ₹6000   EXAM FEE - ₹1500   ELECTRIC FEE - ₹400  '},
  {slno: 6, class: 'CLASS VII & VIII', fees: 'ADMISSION FEE - ₹4000   TUTION FEE - ₹2850   ANNUAL FEE - ₹6500   EXAM FEE - ₹2000   ELECTRIC FEE - ₹400'},
  {slno: 7, class: 'CLASS IX & X', fees: 'ADMISSION FEE - ₹4000   TUTION FEE - ₹3000   ANNUAL FEE - ₹7000   EXAM FEE - 3000   ELECTRIC FEE - ₹400'},
  {slno: 8, class: 'CLASS XI', fees:'ADMISSION FEE - ₹4000   TUTION FEE - ₹3300   ANNUAL FEE - ₹9500   EXAM FEE - ₹3000   ELECTRIC FEE - ₹400'},
  {slno: 9, class: 'CLASS XII', fees: 'ADMISSION FEE - ₹1600   TUTION FEE - ₹3500   ANNUAL FEE - ₹9500   EXAM FEE - ₹3000   ELECTRIC FEE - ₹400'},
];

const ELEMENT_DATA1: PeriodicElement1[] = [
  {slno: 1, class: 'PLAY GROUP', criteria:'MINIMUM 2 YEARS OF AGE'},
  {slno: 2, class: 'NURSERY', criteria: 'MINIMUM 3 YEARS OF AGE'},
  {slno: 3, class: 'JR. KG', criteria:'MINIMUM 4 YEARS OF AGE' },
  {slno: 4, class: 'SR. KG', criteria: 'MINIMUM 5 YEARS OF AGE'},
  {slno: 5, class: 'Grade 1', criteria: 'MINIMUM 6 YEARS OF AGE'},
  {slno: 6, class: 'Above Grade 2', criteria: 'AS APPROPRIATE'},
];
@Component({
  selector: 'app-academic',
  templateUrl: './academic.component.html',
  styleUrls: ['./academic.component.scss']
})
export class AcademicComponent {
  
  classOptions: string[] = [
    'Nursery','LKG','UKG','I','II','III','IV','V',
    'VI','VII','VIII','IX','X','XI','XII'
  ];

  displayedColumns: string[] = ['slno', 'class', 'fees'];
  dataSource = ELEMENT_DATA;

  displayedColumns1: string[] = ['slno', 'class', 'criteria'];
  dataSource1 = ELEMENT_DATA1;

  contactForm!: FormGroup<ContactFormModel>;
  loading = false;

  /** backend model */
  model: VisitorCO = {} as VisitorCO;

  feeRulesHtml = '';

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private snackBar: MatSnackBar,
    private pageDataService: PageDataService
  ) {}

  ngOnInit(): void {
    this.initializeModel();
    this.buildForm();
    this.pageDataService.loadPageData();
    console.log(this.feeRulesHtml)
  }

  pageData$ = this.pageDataService.pageData$.pipe(
    tap(data => {

      if (!data?.length) return;
      console.log(data)
      const page =  data.find(
        page => page?.name?.toLowerCase() === 'academic/admissions'
      );

      if (!page) return; // ✅ type guard
      this.extractAdmissionsData(page);

    })
  );

  private extractAdmissionsData(page: PageCO): void {
    if (!page.category?.length) return;

    const categoryMap = new Map<PageCategoryType, PageCategoryCO>();

    page.category.forEach(cat =>
      categoryMap.set(cat.category, cat)
    );

    this.buildFeeRules(categoryMap);
  }

  feeRulesContent?: PageContentCO;
  feeImage?: string = '';
  feeImg?:PageContentCO;
  private buildFeeRules(map: Map<PageCategoryType, PageCategoryCO>): void {

    const feeRules = map.get(PageCategoryType.FEE_RULES);

    this.feeRulesContent = feeRules?.content?.[0];
    this.feeImg = feeRules?.content?.[1];
    this.feeImage = feeRules?.image?.[0] ? this.getFileUrl(feeRules?.image?.[0].file.fileUUID) : '';
    console.log(this.feeRulesContent)
  }

  private getFileUrl(uuid: string): string {
    return `${ApiUrls.downloadFileUrl1}${uuid}`;
  }

  /** ---------------- INITIAL MODEL ---------------- */
  private initializeModel(): void {
    this.model.enquryType = EnquiryType.Admission;
    this.model.status = VisitorStatus.OPEN;
    this.model.school = { id: environment.schoolId } as SchoolCO;
    this.model.source = SourceType.WEBSITE;
  }

  /** ---------------- FORM ---------------- */
  private buildForm(): void {
    this.contactForm = this.fb.group<ContactFormModel>({
      visitorName: this.fb.control('', {
        nonNullable: false,
        validators: [Validators.required, Validators.minLength(3)]
      }),
      emailId: this.fb.control('', {
        validators: [Validators.required, Validators.email]
      }),
      phoneNo: this.fb.control('', {
        validators: [Validators.required, Validators.pattern(/^[0-9]{10}$/)]
      }),
      admissionClass: this.fb.control( '', {
        validators: Validators.required
      }),
      remarks: this.fb.control('', {
        validators: [Validators.required, Validators.minLength(10)]
      })
    });
  }

  /** ---------------- SUBMIT ---------------- */
  submit(): void {
    if (this.contactForm.invalid || this.loading) {
      this.contactForm.markAllAsTouched();
      return;
    }

    this.loading = true;
    const payload = this.buildVisitorPayload();
    console.log(payload)
    this.apiService.createVisitorEnquiry(payload)
      .pipe(finalize(() => this.loading = false))
      .subscribe({
        next: (res: any) => {
          if (res?.statusCode === 200) {
            this.snackBar.open('Enquiry submitted successfully!', 'Close', { duration: 3000 });
            this.contactForm.reset();
          } else {
            this.snackBar.open(res?.message || 'Submission failed', 'Close', { duration: 3000 });
          }
        },
        error: () => {
          this.snackBar.open('Server error. Please try again later.', 'Close', { duration: 3000 });
        }
      });
  }

  /** ---------------- PAYLOAD BUILDER ---------------- */
  private buildVisitorPayload(): VisitorCO {
    const formValue = this.contactForm.value;

    const now = new Date();
    this.model.enquirydate = now.toLocaleDateString('en-GB');
    this.model.timeIN = now.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit'
    });

    return {
      ...this.model,
      visitorName: formValue.visitorName,
      emailId: formValue.emailId,
      phoneNo: formValue.phoneNo,
      remarks: `Admission for Class: ${formValue.admissionClass}. ${formValue.remarks || ''}`,
    } as VisitorCO;
  }

  /** ---------------- INPUT HELPERS ---------------- */
  allowOnlyNumbers(event: KeyboardEvent): void {
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  get f() {
    return this.contactForm.controls;
  }
}
